export enum AuthenticationMethodEnum {
  COGNITO = "COGNITO",
  DEV = "DEV",
  TOKEN = "TOKEN",
  ANONYMOUS = "ANONYMOUS",
  SYSTEM = "SYSTEM",
}
